import React from 'react';
import {
  LuHouse,
  LuLayoutDashboard,
  LuSearch,
  LuMap,
  LuTag,
  LuMegaphone,
  LuBookOpen,
} from 'react-icons/lu';

/**
 * Minimal outline icons for the profile dropdown (single color, no imagery).
 */

function NavIcon({ Icon, className }) {
  return (
    <span className={className}>
      <Icon aria-hidden />
    </span>
  );
}

export function NavIconHome({ className }) {
  return <NavIcon Icon={LuHouse} className={className} />;
}

export function NavIconDashboard({ className }) {
  return <NavIcon Icon={LuLayoutDashboard} className={className} />;
}

export function NavIconBrowse({ className }) {
  return <NavIcon Icon={LuSearch} className={className} />;
}

export function NavIconMap({ className }) {
  return <NavIcon Icon={LuMap} className={className} />;
}

export function NavIconPricing({ className }) {
  return <NavIcon Icon={LuTag} className={className} />;
}

export function NavIconMegaphone({ className }) {
  return <NavIcon Icon={LuMegaphone} className={className} />;
}

export function NavIconBlog({ className }) {
  return <NavIcon Icon={LuBookOpen} className={className} />;
}
